import { Div } from '../../../base/components/native/div'

export const Size = (text: string) => {

    const base = Div(text)
    base.cssClass({
        padding: '8px 12px',
        margin: '5px',
        borderRadius: '10px',
        border: '2px solid #eee',
        cursor: 'pointer',
    })

    return Object.assign(base, {
        select: () => {
            base.style({
                border: '2px solid #1688f5'
            })
        },
        unselect: () => {
            base.style({
                border: '2px solid #eee'
            })
        }
    })
}